var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSeparatorSingleTop = function SvgSeparatorSingleTop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "703.0mm",
    height: "200.0mm",
    viewBox: "0.0 0.0 703.0 200.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 400,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 200,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    x2: 0,
    y1: 200,
    y2: 200,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 403,
    x2: 400,
    y1: 200,
    y2: 200,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    x2: 403,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 403,
    x2: 603,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 403,
    x2: 603,
    y1: 200,
    y2: 200,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 603,
    x2: 703,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 603,
    x2: 703,
    y1: 200,
    y2: 200,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 703,
    x2: 703,
    y1: 0,
    y2: 200,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    x2: 400,
    y1: 0,
    y2: 200,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 403,
    x2: 403,
    y1: 0,
    y2: 200,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 200,
    y1: 0,
    y2: 200,
    fill: "none",
    stroke: "#cd00ff",
    strokeDasharray: "10 10",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 603,
    x2: 603,
    y1: 0,
    y2: 200,
    fill: "none",
    stroke: "#cd00ff",
    strokeDasharray: "10 10",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSeparatorSingleTop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/separator-single-top.b8ac7b06.svg";
export { ForwardRef as ReactComponent };